import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import { MarketplaceVendor } from "../mockData/marketplaceMockData";

interface Props {
  vendor: MarketplaceVendor;
}

const VIDEO_PATH = "https://youtu.be/0BIaDVnYp2A";

const VendorActionPanel: React.FC<Props> = ({ vendor }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    service: "",
    notes: "",
  });

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success(`Service request sent to ${vendor.name}!`);
    setFormData({ name: "", phone: "", service: "", notes: "" });
  };

  if (vendor.integrationType === "EXTERNAL_LINK" && vendor.externalUrl) {
    return (
      <Box className="vendor_action_panel external">
        <p>Open {vendor.name} to access this service on their platform.</p>
        <Button
          variant="contained"
          className="action_btn primary"
          href={vendor.externalUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit {vendor.name}
        </Button>
      </Box>
    );
  }

  if (vendor.integrationType === "IN_APP_FORM") {
    const services =
      vendor.embeddedType === "vehicle-care"
        ? [
            "Periodic Services",
            "AC Service / Repair",
            "Batteries",
            "Tyre & Wheel Care",
            "Denting & Painting",
            "Car Spa & Cleaning",
          ]
        : ["General Consultation", "Insurance Enquiry", "Claim Support"];

    return (
      <Box className="vendor_action_panel form">
        <h6>Request a Service</h6>
        <form onSubmit={handleFormSubmit}>
          <TextField
            fullWidth
            size="small"
            label="Your Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            margin="dense"
          />
          <TextField
            fullWidth
            size="small"
            label="Phone Number"
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
            required
            margin="dense"
          />
          <TextField
            fullWidth
            size="small"
            select
            SelectProps={{ native: true }}
            label="Service Type"
            InputLabelProps={{ shrink: true }}
            value={formData.service}
            onChange={(e) => setFormData({ ...formData, service: e.target.value })}
            required
            margin="dense"
          >
            <option value="" disabled>
              Select a service
            </option>
            {services.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </TextField>
          <TextField
            fullWidth
            size="small"
            label="Additional Notes"
            value={formData.notes}
            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            multiline
            rows={2}
            margin="dense"
          />
          <Button type="submit" variant="contained" className="action_btn primary">
            Submit Request
          </Button>
        </form>
      </Box>
    );
  }

  if (vendor.integrationType === "EMBEDDED_UI") {
    if (vendor.embeddedType === "wellness") {
      return (
        <Box className="vendor_action_panel embedded wellness_embed">
          <h6>Wellness Videos</h6>
          <Box className="video_grid">
            {[1, 2, 3, 4].map((i) => (
              <Box key={i} className="video_item">
                <ReactPlayer url={VIDEO_PATH} controls width="100%" height="160px" />
              </Box>
            ))}
          </Box>
        </Box>
      );
    }

    if (vendor.embeddedType === "doctor-online") {
      const specialities = [
        "Gynaecology",
        "Pediatrics",
        "General Physician",
        "Dermatology",
        "Psychiatry",
      ];
      return (
        <Box className="vendor_action_panel embedded doctor_embed">
          <h6>Consult a Doctor</h6>
          <Box className="speciality_grid">
            {specialities.map((spec) => (
              <Button key={spec} variant="outlined" className="speciality_btn">
                <img src="/images/consult_specialities_img1.svg" alt="" />
                <span>{spec}</span>
                <small>Consult Now</small>
              </Button>
            ))}
          </Box>
        </Box>
      );
    }
  }

  return null;
};

export default VendorActionPanel;
